import { render, staticRenderFns } from "./Ca.vue?vue&type=template&id=2728a5c0&scoped=true"
import script from "./Ca.vue?vue&type=script&lang=js"
export * from "./Ca.vue?vue&type=script&lang=js"
import style0 from "./Ca.vue?vue&type=style&index=0&id=2728a5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2728a5c0",
  null
  
)

export default component.exports